// What this server HAS (Independent Stays IS8.0, IS8-D4, user 2026-11-03:
// "stays and related should work locally but on prod it should look like they
// not there"). GET /api/app-features answers {stays: true} only when Lobbero
// Stays is switched on (env STAYS_PRODUCT=on); otherwise {} and every Stays
// route is absent.
//
// Signed-in screens need none of this: the session's permissions and
// `products` are already empty of Stays when it is off. This is for what no
// session decides — the public Stays pages (sign-up, the guest's links, the
// Stays legal texts) and the Super Admin console's Stays sections.
//
// ONE request per page load, shared. Until it answers, `staysProduct()` is
// null ("not known yet"): a page waits rather than flashing either way. A
// failed request counts as OFF — a page that cannot ask must not show Stays.
import { useEffect, useState } from 'react';
import { publicApi } from '../api/public-client';

export interface AppFeatures {
  stays: boolean;
}

let known: AppFeatures | null = null;
let pending: Promise<AppFeatures> | null = null;

export const loadAppFeatures = (): Promise<AppFeatures> => {
  if (known) return Promise.resolve(known);
  if (!pending) {
    pending = publicApi
      .get('/app-features')
      .then(res => ({ stays: !!(res && res.data && res.data.stays === true) }))
      .catch(() => ({ stays: false }))
      .then(f => {
        known = f;

        return f;
      });
  }

  return pending;
};

/** true / false once known; null while the first answer is on its way. */
export const useStaysProduct = (): boolean | null => {
  const [on, setOn] = useState<boolean | null>(known ? known.stays : null);
  useEffect(() => {
    let alive = true;
    if (!known) {
      loadAppFeatures().then(f => {
        if (alive) setOn(f.stays);
      });
    }

    return () => {
      alive = false;
    };
  }, []);

  return on;
};

/** Tests only: forget the answer so the next load asks again. */
export const resetAppFeaturesForTests = (value: AppFeatures | null = null): void => {
  known = value;
  pending = null;
};
